import { Fancybox } from '@fancyapps/ui';
import axios from 'smg/axios';
import { SetBootstrapVersion } from 'smg/bootstrap';
import { GetCartID } from 'smg/customer-api/carts';
import { GetPageRequestID } from 'smg/customer-api/pagerequests';
import * as session from 'smg/customer-api/session';
import * as errors from 'smg/errors';
import * as html from 'smg/html';
import { SetIconLibrary } from 'smg/icons';
import * as modals from 'smg/modal';
import { G } from 'smg/querystring';
import * as carts from './carts';
import HolidayBanners from './holiday-banners';
import { Relref } from './hugo';
import AccountSettings from './pages/accountsettings';
import AllPricing from './pages/allpricing';
import BaseballTradingPins from './pages/baseball-trading-pins';
import Cart from './pages/cart';
import ChangePassword from './pages/changepassword';
import Checkout from './pages/checkout';
import CoinStand from './pages/coin-stand';
import Contact from './pages/contact';
import CustomBottleOpeners from './pages/custom-bottle-openers';
import CustomHandcuffBottleOpeners from './pages/custom-hc-bottle-openers';
import CustomPhotoOrnaments from './pages/custom-photo-ornaments';
import CustomTrophies from './pages/customtrophies';
import Dashboard from './pages/dashboard';
import DisplaySizedCoins from './pages/displaysizedcoins';
import Forgot from './pages/forgot';
import IframeQuote from './pages/iframe-quote-form';
import Join from './pages/join';
import Login from './pages/login';
import LoginEmail from './pages/loginemail';
import MakeOrderPayment from './pages/make-order-payment';
import NewTradingPin from './pages/new-trading-pin';
import NoMinimumCustomCoins from './pages/nominimumcustomcoins';
import NotificationSettings from './pages/notification-settings';
import Order from './pages/order';
import Orders from './pages/orders';
import OrderSubmitted from './pages/ordersubmitted';
import PasswordReset from './pages/passwordreset';
import PaymentHistory from './pages/paymenthistory';
import PaymentMethods from './pages/paymentmethods';
import CustomPoliceCoin from './pages/police-coins';
import Quote from './pages/quote';
import Quotes from './pages/quotes';
import RallyTowels from './pages/rally-towels';
import Revisions from './pages/revisions';
import CustomSeptemberCoin from './pages/september-coin';
import ShippingOptions from './pages/shippingoptions';
import StarARushTradingPinDesign from './pages/start-a-rush-trading-pin-design';
import StockProducts from './pages/stock-products';
import TaxExemptions from './pages/taxexemptions';
import Ticket from './pages/ticket';
import TrackOrder from './pages/track';
import Tracking from './pages/tracking';
import Uploads from './pages/uploads';
import VisualQuote from './pages/visualquote';

import './pricing-table';
import './pricing-inline';

import './banner-quote-form';
import './design-template';

import './pages/gallery';
import './pages/usa-coins';
import './pages/uses-page';

void GetPageRequestID();

SetIconLibrary('fontAwesome5');
SetBootstrapVersion(5);

modals.SetDefaults({
    cancelButtonClass: 'btn btn-outline-secondary',
    confirmButtonClass: 'btn btn-secondary',
    closeButtonClass: 'd-none',
    // animation: true,
});

Fancybox.bind('[data-fancybox]', {
    Images: {
        content: (_, slide) => {
            const $picture = document.createElement('picture');

            if (slide.triggerEl?.dataset.srcsetWebp) {
                const $sourceWebp = document.createElement('source');
                $sourceWebp.srcset = slide.triggerEl.dataset.srcsetWebp;
                $sourceWebp.type = 'image/webp';
                $picture.appendChild($sourceWebp);
            }

            const $img = document.createElement('img');
            $img.src = String(slide.src ?? '');
            $picture.appendChild($img);

            if (slide.triggerEl?.dataset.srcset) {
                $img.srcset = slide.triggerEl.dataset.srcset;
            }

            return $picture;
        },
    },
});

errors.Defaults.ShowErrorFunc = msg => new modals.default({
    body: html.FromString(`<div>
            <i class="fas fa-exclamation-circle w-100 text-center mb-5 fa-5x text-danger"></i>
            <div class="fs-4 text-center">${html.Escape(msg)}</div>
        </div>`),
    cancelText: 'Close',
});

function initSession() {
    const navLogin = document.querySelector('#nav-login');
    const navName = document.querySelector('#nav-name') as HTMLElement;
    const mobileLogin = document.querySelector<HTMLAnchorElement>('#mobile-login-logout');
    if (navName) {
        if (session.GetLoginToken()) {
            session.Session().then(sess => {
                navName.textContent = `${sess.firstName} ${sess.lastName}`.trim() || sess.company || 'My Account';

                const navSession = document.querySelector('#nav-session-item') as HTMLElement;
                navSession.classList.remove('d-none');

                if (mobileLogin) {
                    mobileLogin.textContent = 'Logout';
                    mobileLogin.classList.add('logout');
                    mobileLogin.href = '#';
                }

                document.querySelectorAll('.logout').forEach(e => e.addEventListener('click', e => {
                    e.preventDefault();
                    void axios.delete('/sessions').then(() => {
                        session.ClearLoginToken();
                        window.location.reload();
                    });
                }));
            }).catch(err => {
                navLogin?.classList.remove('d-none');
                throw err;
            });
        } else {
            navLogin?.classList.remove('d-none');
            if (mobileLogin) {
                mobileLogin.textContent = 'Login';
                mobileLogin.classList.remove('logout');
                mobileLogin.href = Relref('/login');
            }
        }
    }
}

function initCart() {
    if (!GetCartID()) {
        return;
    }
    carts.GetCartCount().then(count => {
        if (!count) {
            return;
        }

        carts.IncrementCartCount(count);
    }).catch(err => console.error(`failed to get cart count: ${String(err)}`));
}

errors.InitClientSideErrorLogging();

async function main() {
    const loginToken = G().Get('loginToken');
    if (loginToken) {
        G().Delete('loginToken');

        await session.CreateSessionWithLoginToken(loginToken).catch(err => console.warn(err));
    }

    if (G().Get('paypal') === 'success') {
        const successAlert = document.querySelector('#paypal-success') as HTMLElement;
        successAlert.classList.remove('d-none');
        successAlert.addEventListener('closed.bs.alert', () => {
            successAlert.classList.add('d-none');
            G().Delete('paypal');
        });
    }

    if (G().Get('paypal') === 'error') {
        const successAlert = document.querySelector('#paypal-error') as HTMLElement;
        successAlert.classList.remove('d-none');
        successAlert.addEventListener('closed.bs.alert', () => {
            successAlert.classList.add('d-none');
            G().Delete('paypal');
        });
    }

    if (G().Get('deleteCart')) {
        void carts.DeleteCart();
        G().Delete('deleteCart');
    }

    switch (document.body.id) {
    case 'login':
        Login();
        break;
    case 'login-email':
        LoginEmail();
        break;
    case 'join':
        Join();
        break;
    case 'orders':
        void Orders();
        break;
    case 'order':
        void Order();
        break;
    case 'payment-history':
        void PaymentHistory();
        break;
    case 'uploads':
        void Uploads();
        break;
    case 'change-password':
        void ChangePassword();
        break;
    case 'quotes':
        void Quotes();
        break;
    case 'tracking':
        void Tracking();
        break;
    case 'cart':
        void Cart();
        break;
    case 'revisions':
        void Revisions();
        break;
    case 'checkout':
        void Checkout();
        break;
    case 'forgot':
        Forgot();
        break;
    case 'password-reset':
        PasswordReset();
        break;
    case 'account-settings':
        void AccountSettings();
        break;
    case 'dashboard':
        void Dashboard();
        break;
    case 'quote':
        Quote();
        break;
    case 'order-submitted':
        void OrderSubmitted();
        break;
    case 'contact':
        void Contact();
        break;
    case 'shipping-options':
        void ShippingOptions();
        break;
    case 'payment-methods':
        void PaymentMethods();
        break;
    case 'tax-exemptions':
        void TaxExemptions();
        break;
    case 'stock-products':
        StockProducts();
        break;
    case 'new-trading-pin':
        NewTradingPin();
        break;
    case 'make-order-payment':
        void MakeOrderPayment();
        break;
    case 'custom-police-coin':
        void CustomPoliceCoin();
        break;
    case 'custom-september-coin':
        void CustomSeptemberCoin();
        break;
    case 'custom-photo-ornaments':
        void CustomPhotoOrnaments();
        break;
    case 'track':
        void TrackOrder();
        break;
    case 'visual-quote':
        void VisualQuote();
        break;
    case 'notification-settings':
        void NotificationSettings();
        break;
    case 'iframe-quote-form':
        void IframeQuote();
        break;
    case 'display-sized-coins':
        DisplaySizedCoins();
        break;
    case 'coin-stands':
        CoinStand();
        break;
    case 'custom-trophies':
        void CustomTrophies();
        break;
    case 'no-minimum-custom-coins':
        void NoMinimumCustomCoins();
        break;
    case 'ticket':
        void Ticket();
        break;
    case 'start-a-rush-trading-pin-design':
        StarARushTradingPinDesign();
        break;
    case 'all-pricing':
        void AllPricing();
        break;
    case 'custom-bottle-openers':
        void CustomBottleOpeners();
        break;
    case 'custom-handcuff-bottle-openers':
        void CustomHandcuffBottleOpeners();
        break;
    case 'ultimate-trading-pin-guide':
        BaseballTradingPins();
        break;
    case 'rally-towels':
        RallyTowels();
        break;
    }

    initSession();
    initCart();
    HolidayBanners();
}

void main();
